import { StringValue } from '@core/models/base/StatsEvent';
import { AnalyticsProtoEvents } from './analyticsScreenNames';
import { ClickEventType } from './clickAnalytics';
import { MarketForArrange } from '@modules/eventGrid/eventRowUtils';
import { MappedMarket } from '@modules/eventGrid/components/MarketLayouts/MarketLayoutTypes';

export function createSportsClickAnalyticsPayload(clickName: ClickEventType, sportsClick: SportsClick) {
    return {
        AnalyticsEvent: AnalyticsProtoEvents.click,
        eventType: AnalyticsProtoEvents.click,
        [AnalyticsProtoEvents.click]: {
            clickName: clickName,
            clickType: 'sports_click',
            sportsClick,
        },
    };
}

export function getMarketIdFromMarket(market: MarketForArrange | MappedMarket) {
    if ('hasNestedMarkets' in market) {
        const marketIds = market.includedMarkets.map(({ id }) => id);

        return { value: marketIds.length ? marketIds.toString() : market.uniqueId };
    }

    return { value: market.uniqueId || market.id?.toString() || '' };
}

export type SportsClick = {
    matchStatus?: TStatus
    tournamentCode?: StringValue
    sportCode?: StringValue
    marketCode?: StringValue
    matchCode?: StringValue
    clickValue?: StringValue
};

const Status = {
    STATUS_UNSPECIFIED: 0,
    PREMATCH: 1,
    LIVE: 2,
    POSTMATCH: 3,
    NOT_LIVE: 4,
} as const;

type TStatus = typeof Status[keyof typeof Status];
